/**
 * @generated SignedSource<<c58a3791fa91d26ee4731843c7a93d33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formDetailId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FormDetailValuesDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteFormDetailValuesTPayload",
        "kind": "LinkedField",
        "name": "deleteFormDetailValuesTByFormDetailValuesId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FormDetailValuesT",
            "kind": "LinkedField",
            "name": "formDetailValuesT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FormDetailValuesDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteFormDetailValuesTPayload",
        "kind": "LinkedField",
        "name": "deleteFormDetailValuesTByFormDetailValuesId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FormDetailValuesT",
            "kind": "LinkedField",
            "name": "formDetailValuesT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "299a1eea91610ff3063e965a0c05cb20",
    "id": null,
    "metadata": {},
    "name": "FormDetailValuesDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation FormDetailValuesDeleteMutation(\n  $input: DeleteFormDetailValuesTByFormDetailValuesIdInput!\n) {\n  deleteFormDetailValuesTByFormDetailValuesId(input: $input) {\n    formDetailValuesT {\n      formDetailId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "a12c8bf6a2686e6da65b349e3d0f210a";

module.exports = node;
